import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({ title: 'Item Barcode Generation', screenId: '4.1.24', module: 'Procurement', apiPath: 'itembarcode', screenName: 'ItemBarcodeGeneration', idField: 'AutoNo', nameField: 'BarcodePlace',
  gridColumns: [{ field: 'AutoNo', header: 'S.No' }, { field: 'BarcodePlace', header: 'Barcode Place' }, { field: 'Prefix', header: 'Prefix' }, { field: 'RunningNo', header: 'Running No' }, { field: 'Suffix', header: 'Suffix' }, { field: 'StartLength', header: 'Start Length' }, { field: 'BranchPrefix', header: 'Branch Prefix' }],
  formFields: [
    { field: 'AutoNo', label: 'S.No', disabled: true },
    { field: 'BarcodePlace', label: 'Barcode Place', required: true },
    { field: 'Prefix', label: 'Prefix' },
    { field: 'RunningNo', label: 'Running No' },
    { field: 'Suffix', label: 'Suffix' },
    { field: 'StartLength', label: 'Start Length', type: 'number' },
    { field: 'BranchPrefix', label: 'Branch Prefix' }
  ]
});
